"use strict";

exports.__esModule = true;
exports.Api = void 0;

var tslib_1 = require("tslib");
/* tslint:disable */


require("isomorphic-fetch");

var ApiError =
/** @class */
function () {
  function ApiError(message) {
    this.details = null;
    this.message = message;
  }

  return ApiError;
}();
/**
 *
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */


var Api =
/** @class */
function () {
  function Api() {
    this.baseUrl = 'https://calendar.sportnet.online/api/v1';
    this.token = '';
  }

  Api.prototype.serializeQueryParams = function (parameters) {
    return Object.keys(parameters).reduce(function (acc, p) {
      var param = parameters[p];

      if (typeof param === 'undefined' || param === '') {
        return acc;
      }

      return tslib_1.__spreadArrays(acc, [encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p]))]);
    }, []).join('&');
  };

  Api.prototype.transformParameter = function (value, transformOperation) {
    switch (transformOperation) {
      case 'joinUsingPipes':
        return Array.isArray(value) ? value.join('|') : value;

      default:
        return value;
    }
  };

  Api.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
  };

  Api.prototype.setToken = function (token) {
    this.token = token;
  };

  Api.prototype.appendAuthHeaders = function (headerParams) {
    var headers = new Headers(headerParams);

    if (this.token) {
      headers.append('Authorization', "Bearer " + this.token);
    }

    return headers;
  };

  Api.prototype.request = function (method, url, body, headers, queryParameters) {
    if (headers === void 0) {
      headers = new Headers();
    }

    if (queryParameters === void 0) {
      queryParameters = {};
    }

    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var queryParams, urlWithParams, form, k, response, responseContentType, err, _a;

      return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            queryParams = queryParameters && Object.keys(queryParameters).length ? this.serializeQueryParams(queryParameters) : null;
            urlWithParams = url + (queryParams ? '?' + queryParams : '');

            if (headers.get('Content-Type') === 'multipart/form-data') {
              form = new FormData();

              for (k in body) {
                form.append(k, body[k]);
              }

              body = form;
            } else if (headers.get('Content-Type') === 'application/json' && body && Object.keys(body).length > 0) {
              body = JSON.stringify(body);
            } else {
              body = undefined;
            }

            if (headers.get('Content-Type') === 'multipart/form-data') {
              headers["delete"]('Content-Type');
            }

            return [4
            /*yield*/
            , fetch(urlWithParams, {
              method: method,
              headers: headers,
              body: body
            })];

          case 1:
            response = _b.sent();
            if (!response.ok) return [3
            /*break*/
            , 2];
            responseContentType = response.headers && response.headers.get('Content-Type') || '';

            if (responseContentType.includes('application/json')) {
              return [2
              /*return*/
              , response.json()];
            } else if (responseContentType.includes('application/pdf')) {
              return [2
              /*return*/
              , response.blob()];
            } else if (responseContentType.includes('text/plain')) {
              return [2
              /*return*/
              , response.text()];
            }

            return [2
            /*return*/
            , {}];

          case 2:
            err = new ApiError(response.statusText);
            _a = err;
            return [4
            /*yield*/
            , response.json()];

          case 3:
            _a.details = _b.sent();
            throw err;
        }
      });
    });
  };
  /**
   *
   * @method
   * @name Api#getPublicCalendarGroups
   */


  Api.prototype.getPublicCalendarGroups = function (appspace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appspace}/calendargroups';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appspace}', appspace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Return array of public calendars
   * @method
   * @name Api#getCalendarsPublic
   */


  Api.prototype.getCalendarsPublic = function (appspace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appspace}/calendars';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appspace}', appspace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };

  return Api;
}();

exports.Api = Api;
exports["default"] = new Api();